import { UserType } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

export class UserTypeFilter extends Filter<unknown, unknown> {
  readonly id: string = "userTypes";
  readonly labelSingular = "masterdata:UserType";
  readonly labelPlural = "common:UserTypes";
  readonly placeholder = "common:SelectUserTypes";
  readonly searchPlaceholder = "common:SearchUserTypes";
  readonly emptyText = "common:NoUserTypesFound";

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    const options = [
      { id: UserType.Employee, name: "masterdata:Employee" },
      { id: UserType.Guest, name: "masterdata:Guest" },
    ];

    return {
      options,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
